// Where an AI suggestion will go in the template.
export default function PlacementBadge({ item }) {
  const p = item?.placement || {};
  if (p.action === "add_columns") {
    const n = (item.columns || []).filter((c) => c.selected !== false).length;
    return (
      <span className="inline-flex px-1.5 py-0.5 rounded text-[10px] font-medium bg-indigo-100 text-indigo-700 dark:bg-indigo-900/40 dark:text-indigo-300 whitespace-nowrap">
        + {n} column{n !== 1 ? "s" : ""} → {item.display_name || p.target_field_name}
      </span>
    );
  }
  if (p.action === "exists") {
    return (
      <span className="inline-flex px-1.5 py-0.5 rounded text-[10px] font-medium bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400 whitespace-nowrap">
        Already in template
      </span>
    );
  }
  if (item?.not_found_in_sample) {
    return (
      <span
        className="inline-flex px-1.5 py-0.5 rounded text-[10px] font-medium bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300 whitespace-nowrap"
        title="You asked for this field but it isn't in the sample documents. It will be extracted from documents that have it."
      >
        Not in sample
      </span>
    );
  }
  if (p.action === "new_table") {
    return (
      <span className="inline-flex px-1.5 py-0.5 rounded text-[10px] font-medium bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300 whitespace-nowrap">
        New table
      </span>
    );
  }
  return null;
}
